import i18n from '@/api/i18n/i18n';

export const ROUTE_NAMES_FILES = {
  EXTERNAL_DRIVES: 'external-drives',
  SHADOW_COPYINGS: 'shadow-copyings',
  FILE_UPLOAD: 'file-upload',
};

export const ACTIVITY_FEED = 'activityFeed';
export const ROUTE_FILES = 'files';
export const ROUTE_WORKTIME_DETAILS = 'worktimeDetails';
export const ROUTE_HEAT_MAP = 'heatMap';

export const FILES_NAMES = Object.values(ROUTE_NAMES_FILES);
export const ROUTE_NAMES_AUTOTABLE = [ACTIVITY_FEED, ROUTE_FILES];

export const FORMAT_EXPORT = {
  PDF: 'pdf',
  XLS: 'xls',
  CSV: 'csv',
};
export const FILES_FORMAT_EXPORT = {
  PDF: 'pdf',
};

export const EXPORT_OPTIONS = Object.values(FORMAT_EXPORT);
export const FILES_EXPORT_OPTIONS = Object.values(FILES_FORMAT_EXPORT);

export const DATE_OPTIONS = [
  {
    id: 0,
    name: i18n.t('dateOptions.week'),
  },
  {
    id: 1,
    name: i18n.t('dateOptions.month'),
  },
  {
    id: 2,
    name: i18n.t('dateOptions.year'),
  },
  {
    id: 3,
    name: i18n.t('dateOptions.manual'),
  },
];
